import { init } from './init'
import { statistics } from './statistics'
import { coverage } from './coverage'
import { benefit } from './benefit'
import { busCls } from './busCls'
import { stdRisk } from './stdRisk'
import { tariff } from './tariff'
import { uom } from './uom'
import { scheme } from './scheme'

export const mutations = Object.assign(
  {},
  init,
  statistics,
  coverage,
  benefit,
  busCls,
  stdRisk,
  tariff,
  scheme,
  uom
)
